module.exports = __webpack_public_path__ + "static/Ordermark-f93f6630b58800a03df6b8d91d0c7156.jpg";